const hmsToSeconds = (hms: string) => {
  const [hour = '00', minitues = '00', seconds = '00'] = hms.split(':');
  return Number(hour) * 60 * 60 + Number(minitues) * 60 + Number(seconds);
};

export default hmsToSeconds;
